import { BookInformationVariantIcon } from './BookInformationVariantIcon';

/**
 * author: Terren
 * id 4A6A20D1-3F8E-440A-BFB1-38CFB3FB3EC6
 * name book-information-variant
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-information-variant.svg
 * tags
 */
export const EncyclopediaIcon = BookInformationVariantIcon;
export default EncyclopediaIcon